// extracted by mini-css-extract-plugin
export default {"wrapper":"oA-z","viewport":"pA-z","container":"qA-z","slide":"rA-z"};